export class VrCalendarPosition {
  private _classCssTop!: string;

  get classCssTop(): string {
    return this._classCssTop;
  }
  set classCssTop(v: string) {
    this._classCssTop = v;
  }

  setPosition(elementFloat: HTMLElement): void {
    this.setVerticalPosition(elementFloat);
  }

  private setVerticalPosition(element: HTMLElement): void {
    const classTop = this.classCssTop;
    const classList = element.classList;
    const hasClassTop = classList.contains(classTop);

    if (hasClassTop) {
      classList.remove(classTop);
    }

    if (!this.isValidVerticalPosition(element)) {
      classList.add(classTop);
    }

    if (!this.isValidVerticalPosition(element)) {
      classList.remove(classTop);
    }
  }

  private isValidVerticalPosition(element: HTMLElement): boolean {
    const elementHeight = element.offsetHeight;
    const positionTop = this.offset(element).y ?? 0;
    const windowHeight = window.innerHeight;
    return positionTop > 56 && (positionTop + elementHeight) < windowHeight;
  }

  private offset(element: HTMLElement): { x: number, y: number } {
    const rect = element.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { y: rect.top + scrollTop, x: rect.left + scrollLeft };
  }
}
